<footer id="footer" class="footer">

  <div class="container">


    <!-- Bottom -->
    <div class="footer-bottom">
<div class="footer-tagline" dir="ltr">
        <span>Made by </span>
        <span class="gold-dot">•</span>
        <a
  href="https://ape-org.com/"
  target="_blank"
  rel="noopener noreferrer"
>
  <img
    src="assets/images/APElogo (2).png"
    width="50"
    height="30"
    alt="APE"
  />
</a>
      </div>

      <p class="copyright" dir="ltr">
        &copy; {{ currentYear }} PINKY AURA. All rights reserved.
      </p>

      

    </div>

  </div>

</footer>